import React from "react";
import { useNavigate } from "react-router-dom";
import { CourtAuthState, CourtAuthReturnTo } from "src/components/court-auth";
import courtAuthStateRepository from "src/components/court-auth/utils/court-auth-state-repository";

const useLoginWithRetrunTo = () => {
  const navigate = useNavigate();

  const loginWithRetrunTo = () => {
    // 현재 페이지 정보를 latest 에 저장
    const orgState = courtAuthStateRepository.load() ?? ({} as CourtAuthState);
    const orgHistory = orgState.returnTo?.history ?? [];
    const latest = {
      uri: `${window.location.pathname}${window.location.search}`,
      time: Math.floor(new Date().getTime() / 1000),
    } as CourtAuthReturnTo;
    courtAuthStateRepository.save({
      returnTo: { latest, history: [latest, ...orgHistory] },
    });

    // 로그인 페이지로 이동

    navigate("/court/login", { replace: true });
  };

  return { loginWithRetrunTo };
};

export default useLoginWithRetrunTo;
